import React, { Component } from 'react'

export default class Watchlist extends Component {

    render(){
        return (
            <div className='watchlist'>
            {
                this.props.watchlist.map(watchlist => <div className="watch-list">
                    <p>{watchlist.common_name}</p>
                    <p>{watchlist.observation_date}</p>
                    <p>{watchlist.how_many}</p>
                    <p>Latitude: {watchlist.latitude} Longitude: {watchlist.longitude}</p>
                    <button onClick={() => this.props.onDelete(watchlist.id)}>Delete</button>
                    </div>)
                }
            </div>
        )
    }
}
